export const MEMORY_GRAPH_WIDTH = 800;
export const MEMORY_GRAPH_HEIGHT = 440;

export function pruneMemoryNodePositions(positions = {}, nodes = []) {
  const visibleSlugs = new Set((nodes || []).map((node) => node.slug));
  return Object.fromEntries(
    Object.entries(positions || {}).filter(([slug]) => visibleSlugs.has(slug)),
  );
}

export function buildMemoryGraphLayout({
  nodes = [],
  links = [],
  positions = {},
  width = MEMORY_GRAPH_WIDTH,
  height = MEMORY_GRAPH_HEIGHT,
} = {}) {
  const center = { x: width / 2, y: height / 2 };
  const radius = Math.min(270, Math.max(120, 46 * Math.max(nodes.length, 1)));
  const placed = {};

  nodes.forEach((node, index) => {
    const savedPosition = positions[node.slug];
    const angle = (Math.PI * 2 * index) / Math.max(nodes.length, 1) - Math.PI / 2;
    placed[node.slug] = {
      ...node,
      x: savedPosition?.x ?? center.x + Math.cos(angle) * radius,
      y: savedPosition?.y ?? center.y + Math.sin(angle) * radius,
    };
  });

  const laidOutNodes = nodes.map((node) => placed[node.slug]).filter(Boolean);
  const laidOutLinks = links
    .map((link) => ({
      ...link,
      sourceNode: placed[link.source],
      targetNode: placed[link.target],
    }))
    .filter((link) => link.sourceNode && link.targetNode);

  return { width, height, nodes: laidOutNodes, links: laidOutLinks };
}
